var map = {
	"./sucht_A1.png": 82313,
	"./sucht_A2.png": 26511,
	"./sucht_B1.png": 48540,
	"./sucht_B2.png": 70935,
	"./sucht_C1.png": 1675,
	"./sucht_C2.png": 60527,
	"./sucht_D1.png": 2948,
	"./sucht_D2.png": 32528,
	"./sucht_E1.png": 21225,
	"./sucht_E2.png": 1213,
	"./sucht_F1.png": 65658,
	"./sucht_F2.png": 23335,
	"./sucht_G1.png": 43616,
	"./sucht_G2.png": 71788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79503;